// extracted by mini-css-extract-plugin
export default {"Skeleton":"Skeleton_Skeleton__GCp6j","shimmer":"Skeleton_shimmer__Cqf5o"};